var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconBill(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.5 5.66675C5.5 5.39061 5.72386 5.16675 6 5.16675H10C10.2761 5.16675 10.5 5.39061 10.5 5.66675C10.5 5.94289 10.2761 6.16675 10 6.16675H6C5.72386 6.16675 5.5 5.94289 5.5 5.66675Z",
    className: "icon-fill"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.4165 2.75V11.5389L3.85485 10.9812C3.99174 10.807 4.19862 10.7023 4.42003 10.6951C4.64143 10.6878 4.8547 10.7789 5.00267 10.9437L6.22217 12.3025L7.44167 10.9437C7.58391 10.7852 7.78682 10.6947 7.99977 10.6947C8.21272 10.6946 8.41564 10.7852 8.55791 10.9436L9.77743 12.3019L10.997 10.943C11.145 10.7782 11.3582 10.6872 11.5796 10.6944C11.8011 10.7016 12.0079 10.8064 12.1448 10.9805L12.5832 11.5382V2.75H3.4165ZM1.9165 2.66667C1.9165 1.88445 2.55096 1.25 3.33317 1.25H12.6665C13.4487 1.25 14.0832 1.88445 14.0832 2.66667V12.794C14.0832 13.6017 13.2343 14.1213 12.5159 13.7632C12.4166 13.7137 12.3294 13.6427 12.2608 13.5555L11.5171 12.6093L10.4847 13.7596C10.4213 13.8303 10.345 13.8882 10.26 13.9304C9.95591 14.0814 9.5991 14.0814 9.295 13.9304C9.21002 13.8882 9.13382 13.8303 9.07043 13.7597L7.99994 12.5674L6.92933 13.7603C6.86593 13.8309 6.7897 13.8889 6.70467 13.9311C6.40057 14.0821 6.04377 14.0821 5.73967 13.9311C5.65465 13.8889 5.57841 13.8309 5.51501 13.7603L4.48255 12.6099L3.73883 13.5561C3.66985 13.6439 3.58217 13.7151 3.48216 13.7647C2.76483 14.1201 1.9165 13.6019 1.9165 12.794V2.66667Z",
    className: "icon-fill"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.5 8.33325C5.5 8.05711 5.72386 7.83325 6 7.83325H8.66667C8.94281 7.83325 9.16667 8.05711 9.16667 8.33325C9.16667 8.60939 8.94281 8.83325 8.66667 8.83325H6C5.72386 8.83325 5.5 8.60939 5.5 8.33325Z",
    className: "icon-fill"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBill);
export default __webpack_public_path__ + "static/media/icon-bill.fd225a40621642c4194a62e8acb6303e.svg";
export { ForwardRef as ReactComponent };